import { CommonModule } from '@angular/common';
import { Component, OnDestroy, computed, effect, inject, input, output, signal } from '@angular/core';
import { FilterValue, MappedFilter } from 'src/app/products/services/filters-adapter.service';
import { CheckboxFilterComponent } from "../../checkbox-filter/checkbox-filter.component";
import { ResetFiltersService } from '../reset-filters.service';

@Component({
  standalone: true,
  selector: 'common-filter',
  templateUrl: './common-filter.component.html',
  styleUrls: ['./common-filter.component.scss'],
  imports: [CommonModule, CheckboxFilterComponent]
})
export class CommonFilterComponent implements OnDestroy {
  private resetFiltersService = inject(ResetFiltersService);

  private _checkboxFilterInput = signal<MappedFilter>({} as MappedFilter);
  private _checkedFilters = signal<any[]>([]);
  private _label = signal<string>('');

  checkboxFilterInput = input<MappedFilter | null>(null);
  checkedFilters = input<any[]>([]);
  label = input<string>('');

  // Update output to use Angular 20 output() function
  selectedFilter = output<FilterValue>();

  constructor() {
    // Effects to handle input changes
    effect(() => {
      const value = this.checkboxFilterInput();
      if (value && Array.isArray(value?.filters)) {
        this._checkboxFilterInput.set(value);
      } else {
        this._checkboxFilterInput.set({} as MappedFilter);
      }
    });

    effect(() => {
      const value = this.checkedFilters();
      this._checkedFilters.set(value);
    });

    effect(() => {
      const value = this.label();
      this._label.set(value);
    });
  }

  selectFilter(value: FilterValue) {
    this.selectedFilter.emit(value);
  }

  checkIfSelected(value: any) {
    return this._checkedFilters().find(filter => filter.event === value);
  }

  // Computed properties
  readonly type = computed(() => this._checkboxFilterInput()?.type || null);

  readonly filterValues = computed(() => {
    const label = this._label();
    const filters = this._checkboxFilterInput()?.filters;

    if (label === 'size') {
      if (!filters) return null;

      const numberArray = filters.sort((a, b) =>
        (+a.value) - (+b.value)
      ).filter(number => !Number.isNaN(+number.value));

      const letterSize = filters.filter(_filter => Number.isNaN(+_filter.value)).sort();

      return [...letterSize, ...numberArray];
    } else {
      return filters || null;
    }
  });

  ngOnDestroy() {
    // No cleanup needed with signals
  }

}

